<template>
  <Doughnut :chart-data="chartData" :chart-options="options" :plugins="plugins" />
</template>

<script>
// TODO: このコンポーネントを無くして、直接vue-chart.jsを使うようにしてツリーシェイキングさせる
// https://vue-chartjs.org/migration-guides/#tree-shaking
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Tooltip } from 'chart.js'
import { fontString } from 'chart.js/helpers'

ChartJS.register(Tooltip)

export default {
  name: 'ChartDoughnut',
  components: { Doughnut },
  props: ['options', 'chartData', 'text'],
  computed: {
    plugins() {
      const centerText = this.text
      return [
        {
          afterDraw(chart) {
            let ctx = chart.ctx

            // Center text
            if (centerText === 0 || centerText) {
              let fontSize = 24
              let fontStyle = 'bold'
              let fontFamily = 'Helvetica Neue'
              ctx.fillStyle = '#3A3B3F'
              ctx.font = fontString(fontSize, fontStyle, fontFamily)
              ctx.textAlign = 'center'
              ctx.textBaseline = 'middle'
              ctx.fillText(centerText, chart.width / 2, chart.height / 2)
            }
          }
        }
      ]
    }
  }
}
</script>
